export { default as Discord } from './src/discord.vue';
